import { AlignType } from "rc-table/lib/interface";

export const BANNERS_TABLE_COLUMN = [
  {
    title: "تصویر بنر",
    dataIndex: "image",
    key: "image",
    align: "center" as AlignType,
  },
  {
    title: "نام بنر و تاریخ ثبت",
    dataIndex: "title",
    key: "title",
    align: "center" as AlignType,
  },
  {
    title: "حجم فایل",
    dataIndex: "size",
    key: "size",
    align: "center" as AlignType,
  },
  {
    title: "لینک",
    dataIndex: "link",
    key: "link",
    align: "center" as AlignType,
  },
  {
    title: "وضعیت",
    dataIndex: "status",
    key: "status",
    align: "center" as AlignType,
  },
  {
    title: "عملیات",
    dataIndex: "action",
    key: "action",
    align: "center" as AlignType,
  },
];

export const CATEGORY_PRODCUTS_TABLE_COLUMN = [
  {
    title: "ردیف",
    dataIndex: "index",
    key: "index",
    align: "center" as AlignType,
    width: "5%",
  },
  {
    title: "نام محصول",
    dataIndex: "product",
    key: "product",
    width: "50%",
  },
  {
    title: "عملیات",
    dataIndex: "action",
    key: "action",
    align: "center" as AlignType,
    width: "5%",
  },
];
